import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Moment from 'moment';
import { updateMDInfo, updateMIInfo, updateRDInfo, updateMDRemarks,deleteMIInfo,deleteEUInfo } from "../Actions/MDUpdateAPI";
import { getMaterialDetails } from "../Actions/MDDetailAPI";
import { DownloadAttachment } from '../Actions/AttachmentAPI';
import { AddAttachment,AddSDocAttachment } from "../Actions/AttachmentAPI";
import { confirmAlert } from 'react-confirm-alert';
import appService from '../Actions/appService';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { css } from "glamor";
//import AutoComplete from '../core-ui/AutoComplete';
import { AutoComplete } from 'primereact/autocomplete';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import { postMI,postEU } from "../Actions/MDNewItemAPI";
toast.configure();
const MIlistInput = {
    tableValue: '', materialName: '', thresholdValue: '', isContainAboveThreshold: false,
    mass: '', unit: '', informationOnUsage: '', tabletype: 'Other', materialDeclarationId: '', createdBy: ''
}
const EulistInput = {
    tableValue: '', materialName: '', thresholdValue: '', isContainAboveThreshold: false,
    mass: '', unit: '', informationOnUsage: '', tabletype: 'Eu', materialDeclarationId: '', createdBy: ''
}
const RDlistInput = {
    attachmentType: '', remarks: '', dateOfDeclaration: '', documentCreationOrganization: '', attachmentName: '', attachmentGuid: '', materialDeclarationId: '', modifiedBy: '', isDeleted: false
}

class MDEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            DatePickerIsOpen: false, RDDatePickerIsOpen: false, SelecteddateofDeclaration: '', SelectedRDDate: '', dateOfDeclaration: '', RDDate: '',
            errorMessage: false, MICheckBox: false, EuCheckBox: false, file: '', fileName: '', MDClear: true, changesInAttachment: false,mdfile:'',flag:false,
            MDInput: {
                dateofdeclaration: '', mdidno: '', companyname: '', divisionname: '', address: '',
                telephone: '', fax: '', email: '', sdocIdNo: '', productnumber: '',
                productname: '', productinfo: '', contactperson: '', productQuantityAmount: '', productmetricunit: '',
                materialQuantityAmount: '', materialmetricunit: '', createdby: '',attachmentName:'',attachmentGuid:''
            },
            MIInput: {
                tableValue: '', materialname: '', thresholdvalue: '', isContainAboveThreshold: false,
                mass: '', unit: '', informationOnUsage: '', tabletype: 'Other'
            },

            RDInput: {
                attachmentType: '', remarks: '', dateOfDeclaration: '', documentCreationOrganization: ''
            },
            MIRenderArray: [],
            EURenderArray: [],
            MIInputArray: [],
            EuInputArray: [],
            RDRenderArray: [],
            Remark1: '', Remark2: '', Remark3: '',
            //temp array for updating tables

            MItempArray: [], MItempCardNo: '', EUtempArray: [], EUtempcardNo: '', RDtempcardNo: '', RDtempArray: [],
            MITableDropDown:[],MIMaterialNameDropDown:[],MITVDropDown:[],EUTableDropDown:[],EUMaterialNameDropDown:[],EUTVDropDown:[],
            GetMaterialInfo:false,MItable:[],MImaterial:[],MIthreshold:[],EUtable:[],EUmaterial:[],EUthreshold:[]
        }
        this.openDatePicker = this.openDatePicker.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleMDInputChange = this.handleMDInputChange.bind(this);
        this.updateMD = this.updateMD.bind(this);
        this.handleMIInputChange = this.handleMIInputChange.bind(this);
        this.handleMICheckBoxChange = this.handleMICheckBoxChange.bind(this);
        this.handleEuCheckBoxChange = this.handleEuCheckBoxChange.bind(this);
        this.handleRDInputChange = this.handleRDInputChange.bind(this);
        this.AddMIData = this.AddMIData.bind(this);
        this.AddEUData = this.AddEUData.bind(this);
        this.AddRDData = this.AddRDData.bind(this);
        this.openRDDatePicker = this.openRDDatePicker.bind(this);
        this.handleRDDateChange = this.handleRDDateChange.bind(this);
        this.handleEuInputChange = this.handleEuInputChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch } = nextProps;
        if (nextProps.attachmentDetail && nextProps.isAttachment) {
            if (prevState.file.name === nextProps.attachmentDetail.FileName && prevState.file.name !== '') {
                prevState.RDRenderArray.map((obj) => {
                    if (prevState.file.name === obj.documentCreationOrganization) {
                        obj.attachmentGuid = nextProps.attachmentDetail.Guid;
                        obj.attachmentName = nextProps.attachmentDetail.FileName;
                        prevState.file = '';
                    }
                    return obj
                });
            }
        }
        if (nextProps.MdAttachment) {
            prevState.MDInput.attachmentName=nextProps.MdAttachment.FileName;
            prevState.MDInput.attachmentGuid=nextProps.MdAttachment.Guid;
            prevState.mdfile = '';            
        }
        // if(prevState.mdfile!==""){
        //     dispatch(AddSDocAttachment(prevState.mdfile))
        //     prevState.mdfile='';
        // }
        if (nextProps.MIOthersList && nextProps.MIOthersList !== prevState.MIRenderArray) {
            prevState.MIRenderArray = nextProps.MIOthersList;
        }
        if (nextProps.MIEuList && nextProps.MIEuList !== prevState.EURenderArray) {
            prevState.EURenderArray = nextProps.MIEuList;
        }
        if (nextProps.RDList && nextProps.RDList !== prevState.RDRenderArray) {
            prevState.RDRenderArray = nextProps.RDList;
        }
        if (nextProps.mdDetailList !== [] && nextProps.mdDetailList && prevState.mdDetailList !== nextProps.mdDetailList && prevState.MDClear) {
            prevState.mdDetailList = nextProps.mdDetailList;
            prevState.MDInput = nextProps.mdDetailList;
            prevState.MDClear = false;
            dispatch({
                type: "ClearMdDetailList",
                data: nextProps.mdDetailList
            })
        }
    }
    handleMDInputTextareaChange(e, arrayIndex) {
        const { RemarksList } = this.props;
        RemarksList[arrayIndex].remarks = e.target.value;
        this.setState({ RemarksList });
    }
    updateMD() {
        const { dispatch, RemarksList, match, userDisplayName } = this.props;
        const { params } = match;
        const { id } = params;
        this.state.MDInput.modifiedBy = userDisplayName;
        let attachId='',attachType='';
        if(this.state.MDInput.mdAttachment){
            this.state.MDInput.mdAttachment.map((da)=>{
                attachId=da.attachmentId;
                attachType=da.attachmentType;
            })
        }
        // if attach present
        if(attachId !=null && attachId!='')
        {
            const MdData={
                materialDeclarationId:this.state.MDInput.materialDeclarationId,
                dateOfDeclaration: this.state.MDInput.dateOfDeclaration,
                mdidNo: this.state.MDInput.mdidNo,
                companyName: this.state.MDInput.companyName,
                divisionName: this.state.MDInput.divisionName,
                address: this.state.MDInput.address,
                telephone: this.state.MDInput.telephone,
                fax: this.state.MDInput.fax,
                email: this.state.MDInput.email,
                sdocIdNo: this.state.MDInput.sdocIdNo,
                productNumber: this.state.MDInput.productNumber,
                productName: this.state.MDInput.productName,
                productInfo: this.state.MDInput.productInfo,
                contactPerson: this.state.MDInput.contactPerson,
                productQuantityAmount: this.state.MDInput.productQuantityAmount,
                productMetricUnit: this.state.MDInput.productMetricUnit,
                materialQuantityAmount: this.state.MDInput.materialQuantityAmount,
                materialMetricUnit: this.state.MDInput.materialMetricUnit,
                // createdDate:this.state.MDInput.createdDate,
                // createdBy:this.state.MDInput.createdBy,
                // modifiedDate:this.state.MDInput.modifiedDate,
                modifiedBy: this.state.MDInput.modifiedBy,
                // isDeleted:this.state.MDInput.isDeleted,          
                attachmentId:attachId,
                // attachmentType:attachType,
                attachmentName: this.state.MDInput.attachmentName,
                attachmentGuid: this.state.MDInput.attachmentGuid
            }
            dispatch(updateMDInfo(MdData));
        }
        // if attach not present
       else
       {
        const MdData={
            materialDeclarationId:this.state.MDInput.materialDeclarationId,
            dateOfDeclaration: this.state.MDInput.dateOfDeclaration,
            mdidNo: this.state.MDInput.mdidNo,
            companyName: this.state.MDInput.companyName,
            divisionName: this.state.MDInput.divisionName,
            address: this.state.MDInput.address,
            telephone: this.state.MDInput.telephone,
            fax: this.state.MDInput.fax,
            email: this.state.MDInput.email,
            sdocIdNo: this.state.MDInput.sdocIdNo,
            productNumber: this.state.MDInput.productNumber,
            productName: this.state.MDInput.productName,
            productInfo: this.state.MDInput.productInfo,
            contactPerson: this.state.MDInput.contactPerson,
            productQuantityAmount: this.state.MDInput.productQuantityAmount,
            productMetricUnit: this.state.MDInput.productMetricUnit,
            materialQuantityAmount: this.state.MDInput.materialQuantityAmount,
            materialMetricUnit: this.state.MDInput.materialMetricUnit,
            // createdDate:this.state.MDInput.createdDate,
            // createdBy:this.state.MDInput.createdBy,
            modifiedDate:this.state.MDInput.modifiedDate,
            modifiedBy: this.state.MDInput.modifiedBy,
            // isDeleted:this.state.MDInput.isDeleted, 
            attachmentName: this.state.MDInput.attachmentName,
            attachmentGuid: this.state.MDInput.attachmentGuid                   
        }
        dispatch(updateMDInfo(MdData));
       }
      
        this.state.MIRenderArray.push.apply(this.state.MIRenderArray, this.state.EURenderArray);
        dispatch(updateMIInfo(this.state.MIRenderArray))
        dispatch(updateRDInfo(this.state.RDRenderArray))
        let updatedRemark = [
            {
                materialdeclarationid: RemarksList[0].materialDeclarationId,
                mdremarksid: RemarksList[0].mdremarksId,
                remarks: RemarksList[0].remarks,
                modifiedBy: userDisplayName
            },
            {
                materialdeclarationid: RemarksList[1].materialDeclarationId,
                mdremarksid: RemarksList[1].mdremarksId,
                remarks: RemarksList[1].remarks,
                modifiedBy: userDisplayName
            },
            {
                materialdeclarationid: RemarksList[2].materialDeclarationId,
                mdremarksid: RemarksList[2].mdremarksId,
                remarks: RemarksList[2].remarks,
                modifiedBy: userDisplayName
            },
        ]
        dispatch(updateMDRemarks(updatedRemark));
        toast("MD Item Updated Successfully", {
            className: css({
              background: "#eee !important",
              color: "black !important",
              fontWeight: "bold"
            }),
            closeOnClick: false,
            autoClose: 2000,
            closeButton: false,
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true
          });
          dispatch({ type: 'MDDetail'});
        this.props.history.push('/Home');
    }
    
    AddMIData=async()=> {
        const { match } = this.props;
        const { params } = match;
        const { id } = params;
        // var joined = this.state.MIRenderArray;
        var joined = [];
        this.state.MItempArray.materialDeclarationId = id;
        joined.push({ ...this.state.MItempArray });
        await  this.props.dispatch(postMI(joined,id));
        let param = { ...MIlistInput };
        this.setState({
            // MIRenderArray: joined,
            MItempArray: param,
            MICheckBox: false,flag:true
        })
        this.props.dispatch(getMaterialDetails("other", "", "", ""));
    }
    UpdateMIData(index) {
        this.state.MIRenderArray[index] = { ...this.state.MItempArray };
        this.setState({
            MICheckBox: false,
            MItempArray: MIlistInput,
            MIInput: MIlistInput,
            MItempCardNo: 0
        })
    }
    UpdateEUData(index) {
        this.state.EURenderArray[index] = { ...this.state.EUtempArray };
        this.setState({
            EuCheckBox: false,
            EUtempArray: EulistInput,
            EUtempcardNo: 0
        })
    }
    editMICard = (item, tableName) => {
        const { ShowMISidePan, ShowEURegSidePan } = this.props;
        if (tableName === "Other") {
            this.state.MItempArray = { ...this.state.MIRenderArray[item] };
            this.state.MItempCardNo = item + 1;
            this.setState({
                MICheckBox: this.state.MItempArray.isContainAboveThreshold,flag:true
            })
            if (!ShowMISidePan)
                this.props.dispatch({ type: 'ShowMISidePan', data: true });
                appService.getMaterialDetail("other","","","").then(response => {
                    if(response.data[0]){
                        this.setState({
                            MItable:response.data[0].tablevalue,
                            MImaterial:response.data[0].materialname,
                            MIthreshold:response.data[0].thresholdvalue,
                            GetMaterialInfo:true
                        });
                    }
                })
        }
        else {
            this.state.EUtempArray = { ...this.state.EURenderArray[item] };
            this.state.EUtempcardNo = item + 1;
            this.setState({
                EuCheckBox: this.state.EUtempArray.isContainAboveThreshold,flag:true
            });
            if (!ShowEURegSidePan)
                this.props.dispatch({ type: 'ShowEURegSidePan', data: true });
                appService.getMaterialDetail("Eu","","","").then(response => {
                    if(response.data[0]){
                        this.setState({
                            EUtable:response.data[0].tablevalue,
                            EUmaterial:response.data[0].materialname,
                            EUthreshold:response.data[0].thresholdvalue,
                            GetMaterialInfo:true
                        });
                    }
                })
        }
        document.body.scrollTop=0;
        document.documentElement.scrollTop=300;
    }
    editRDCard = (item) => {
        const { ShowRDSidePan } = this.props;
        this.state.RDtempArray = { ...this.state.RDRenderArray[item] };
        this.setState({
            RDtempcardNo: item + 1
        })

        if (!ShowRDSidePan)
            this.props.dispatch({ type: 'ShowRDSidePan', data: true });
        document.body.scrollTop=0;
        document.documentElement.scrollTop=300;
    }
   
    AddEUData=async()=> {
        const { match } = this.props;
        const { params } = match;
        const { id } = params;
        // var joined = this.state.EURenderArray;
        var joined = [];
        this.state.EUtempArray.materialDeclarationId = id;
        joined.push({ ...this.state.EUtempArray });
        await  this.props.dispatch(postEU(joined,id));
        let param = { ...EulistInput };
        this.setState({ EURenderArray: joined, EUtempArray: param, EuCheckBox: false })
        this.props.dispatch(getMaterialDetails("EU", "", "", ""));
    }
    AddRDData() {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { id } = params;
        var joined = this.state.RDRenderArray;
        this.state.RDtempArray.materialDeclarationId = id;
        joined.push({ ...this.state.RDtempArray });
        dispatch(AddAttachment(this.state.file))
        this.setState({ RDRenderArray: joined, RDtempArray: RDlistInput })
    }
    handleDateChange(date) {
        this.state.MDInput.dateOfDeclaration = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
        this.setState({
            DatePickerIsOpen: false,
            SelecteddateofDeclaration: date,
            dateofDeclaration: this.state.MDInput.dateOfDeclaration,
        })
    }
    handleRDDateChange(date) {
        this.state.RDtempArray.dateOfDeclaration = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
        this.setState({
            SelectedRDDate: date,
            RDDatePickerIsOpen: false
        });
    }
    openDatePicker() {
        this.setState({
            DatePickerIsOpen: !this.state.DatePickerIsOpen,
        });
    };
    openRDDatePicker() {
        this.setState({
            RDDatePickerIsOpen: !this.state.RDDatePickerIsOpen,
        });
    };
    handleBlur() {
        this.setState({
            DatePickerIsOpen: false,
            RDDatePickerIsOpen: false,
        });
      }
    handleMDInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "productQuantityAmount" || nodeName === "materialQuantityAmount"){
            this.state.MDInput[nodeName] = parseInt(e.target.value);
        } else if(nodeName==="sdocIdNo"){
            this.state.MDInput[nodeName] = e.target.files[0].name;
            this.state.mdfile=e.target.files[0];
            this.setState({})
           this.props.dispatch(AddSDocAttachment(this.state.mdfile));
               
            
        }
        else{
            this.state.MDInput[nodeName] = e.target.value;
        }
        this.setState({
            [nodeName]: e.target.value
        });
    }
    handleMIInputChange(e) {
        let nodeName = e.target.name;
        const { dispatch } = this.props;
        this.state.MItempArray[nodeName] = e.target.value;

        this.setState({
            DatePickerIsOpen: false
        });
        if (nodeName === "tableValue") {
            appService.getMaterialDetail("other",this.state.MItempArray.tableValue,"","").then(response => {
                if(response.data[0]){
                    this.setState({
                        MImaterial:response.data[0].materialname,
                    });
                }
            })
            this.state.MItempArray.materialName="";
            this.state.MItempArray.thresholdValue="";
        }else if(nodeName==="materialName"){
            appService.getMaterialDetail("other",this.state.MItempArray.tableValue,"",this.state.MItempArray.materialName).then(response => {
                if(response.data[0]){
                    this.setState({
                        MIthreshold:response.data[0].thresholdvalue,
                    });
                }
            })
            
        }
    }
    handleEuInputChange(e) {
        let nodeName = e.target.name;
        const { dispatch } = this.props;
        this.state.EUtempArray[nodeName] = e.target.value;

        this.setState({
            DatePickerIsOpen: false
        });
        if (nodeName === "tableValue") {
            appService.getMaterialDetail("Eu",this.state.EUtempArray.tableValue,"","").then(response => {
                if(response.data[0]){
                    this.setState({
                        EUmaterial:response.data[0].materialname,
                    });
                }
            })
            this.state.EUtempArray.materialName="";
            this.state.EUtempArray.thresholdValue="";
        }else if(nodeName==="materialName"){
            appService.getMaterialDetail("Eu",this.state.EUtempArray.tableValue,"",this.state.EUtempArray.materialName).then(response => {
                if(response.data[0]){
                    this.setState({
                        EUthreshold:response.data[0].thresholdvalue,
                    });
                }
            })  
        }
    }
    handleRDInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName !== "documentCreationOrganization")
            this.state.RDtempArray[nodeName] = e.target.value;
        else {
            this.state.changesInAttachment = true;
            this.state.RDtempArray[nodeName] = e.target.files[0].name;
            this.state.file = e.target.files[0];
            this.state.fileName = e.target.files[0].name;
        }

        this.setState({

        });
    }
    handleMICheckBoxChange(e) {
        this.state.MItempArray['isContainAboveThreshold'] = e.target.checked;
        this.setState({
            MICheckBox: e.target.checked
        })
    }
    handleEuCheckBoxChange(e) {
        this.state.EUtempArray['isContainAboveThreshold'] = e.target.checked;
        this.setState({
            EuCheckBox: e.target.checked
        })
    }
    DeleteEUData=async(index)=> {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { id } = params;
            confirmAlert({
                message: 'Are you sure want to delete ?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: async() => {
                            this.state.EURenderArray[index].isDeleted=true;
                            // this.state.EURenderArray.splice(index, 1);
                            await dispatch(deleteEUInfo(this.state.EURenderArray,id))
                            let param = { ...EulistInput }
                            this.setState({
                               EUtempArray: param
                            });
                        }
                    },
                    {
                        label: 'No',
                        onClick: () => { }
                    }
                ]
            });
    };

    
    DeleteMIData=async(index)=> {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { id } = params;
        confirmAlert({
            message: 'Are you sure want to delete ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: async() => {
                        this.state.MIRenderArray[index].isDeleted=true;
                        // this.state.MIRenderArray.splice(index, 1);
                        await dispatch(deleteMIInfo(this.state.MIRenderArray,id))
                        let param = { ...MIlistInput }
                        this.setState({
                            MItempArray: param
                        });
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }
    DeleteRDData(index) { 
        confirmAlert({
        message: 'Are you sure want to delete ?',
        buttons: [
            {
                label: 'Yes',
                onClick: () => {
                        // this.state.RDRenderArray[index].isDeleted=true;
                        this.state.RDRenderArray.splice(index, 1);
                        let params = { ...RDlistInput }
                        this.setState({
                            RDtempArray: params
                        });
                }
            },
            {
                label: 'No',
                onClick: () => { }
            }
        ]
    });
    }
    ClearInput() {
        this.state.RDtempArray.documentCreationOrganization = '';
        this.setState({ file: '',mdfile:'' });
        this.state.MDInput.sdocIdNo=''
    }
    updateRDData(index) {
        const { dispatch } = this.props;
        this.state.RDRenderArray[index] = { ...this.state.RDtempArray };
        dispatch(AddAttachment(this.state.file))
        this.setState({
            RDtempArray: RDlistInput,
            RDtempcardNo: 0
        })
    }
    CancelMD() {
        this.props.history.push('/Home');
        this.props.dispatch({ type: 'ShowSidePan', data: false });
        this.props.dispatch({ type: 'MDDetail'});
    }
    suggestMItable(event) {
        let results = this.state.MItable.filter((table) => {
             return table.toLowerCase().indexOf(event.query.toLowerCase())>-1;
        });
    
        this.setState({ MITableDropDown: results });
    }
    suggestMImaterial(event){
        let results = this.state.MImaterial.filter((material) => {
            return material.toLowerCase().indexOf(event.query.toLowerCase())>-1;
       });
   
       this.setState({ MIMaterialNameDropDown: results });
    }
    suggestMIthreshold(event){
        let results = this.state.MIthreshold.filter((threshold) => {
            return threshold.toLowerCase().indexOf(event.query.toLowerCase())>-1;
       });
   
       this.setState({ MITVDropDown: results });
    }
    suggestEUtable(event) {
        let results = this.state.EUtable.filter((table) => {
             return table.toLowerCase().indexOf(event.query.toLowerCase())>-1;
        });
    
        this.setState({ EUTableDropDown: results });
    }
    suggestEUmaterial(event){
        let results = this.state.EUmaterial.filter((material) => {
            return material.toLowerCase().indexOf(event.query.toLowerCase())>-1;
       });
   
       this.setState({ EUMaterialNameDropDown: results });
    }
    suggestEUthreshold(event){
        let results = this.state.EUthreshold.filter((threshold) => {
            return threshold.toLowerCase().indexOf(event.query.toLowerCase())>-1;
       });
   
       this.setState({ EUTVDropDown: results });
    }
    render() {
        const {
            ShowMISidePan, ShowRDSidePan, ShowEURegSidePan, MInfoList, RemarksList
        } = this.props;

        return (
            <div className="full-height">
                
                <div className="row" style={{ height: "50px" }}>

                </div>
                <div className="grey-bg  course-list-page row  p-3">
                    <div className={(ShowMISidePan || ShowRDSidePan || ShowEURegSidePan) ? "col-lg-6 p-4 mobile" : 'p-4'}>
                        <div className="panel-box search-filter-box">

                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>MD Declaration</h5></div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label" >Date of Declaration</label><br></br>
                                    <div className='input-group add-on date datepicker' data-date-format="yyyy-mm-dd">
                                        <input type="text" value={Moment(new Date(Date.parse(this.state.MDInput.dateOfDeclaration))).format('YYYY-MM-DD')} className="form-control date-picker" placeholder="From Date" name='dateofDeclaration'></input>
                                        <DatePicker selected={this.state.SelecteddateofDeclaration} onChange={this.handleDateChange}
                                            open={this.state.DatePickerIsOpen}  onClickOutside={this.handleBlur}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            className="form-control date-picker w-5 hide-date" />
                                        <div className="input-group-btn calendar-icon" onClick={this.openDatePicker}>
                                            <button className="btn btn-default">
                                                <i className="fa fa-calendar mt-1"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >MD ID No</label><br></br>
                                    <input className="form-control" type="text" name="mdidNo" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.mdidNo}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >Company Name</label><br></br>
                                    <input className="form-control" type="text" name="companyName" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.companyName}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >Division Name</label><br></br>
                                    <input className="form-control" type="text" name="divisionName" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.divisionName}></input>
                                </div>

                                <div className="col-lg-4">
                                    <label className="form-label" >Contact Person</label><br></br>
                                    <input className="form-control" type="text" name="contactPerson" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.contactPerson}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >Telephone Number</label><br></br>
                                    <input className="form-control" type="text" name="telephone" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.telephone}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >Fax No</label><br></br>
                                    <input className="form-control" type="text" name="fax" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.fax}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >Email</label><br></br>
                                    <input className="form-control" type="email" name="email" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.email}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >SDoC ID No</label><br></br>
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Browse File<input type="file" id="files" name="sdocIdNo" onChange={(e) => this.handleMDInputChange(e)} /></span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="" value={this.state.MDInput.sdocIdNo} />
                                        {
                                            this.state.MDInput.sdocIdNo ? <div class="input-group-append">
                                                <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInput()}></i>
                                            </div> : ''
                                        }
                                      </div>
                                    {/* <input className="form-control" type="text" name="sdocIdNo" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.sdocIdNo}></input> */}
                                </div>
                                <div className="col-lg-12">
                                    <label className="form-label" >Address</label><br></br>
                                    <textarea className="form-control" rows='3' name="address" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.address}></textarea>
                                </div>
                                <div className="col-lg-12">
                                    <label className="form-label" >Remark 1</label><br></br>
                                    <textarea className="form-control" rows='3' name="Remark1" onChange={(e) => this.handleMDInputTextareaChange(e, 0)} value={(RemarksList && RemarksList !== []) ? RemarksList[0].remarks : ''}></textarea>
                                </div>
                                <div className="col-lg-12">
                                    <label className="form-label" >Remark 2</label><br></br>
                                    <textarea className="form-control" rows='3' name="Remark2" onChange={(e) => this.handleMDInputTextareaChange(e, 1)} value={(RemarksList && RemarksList !== []) ? RemarksList[1].remarks : ''}></textarea>
                                </div>
                                <div className="col-lg-12">
                                    <label className="form-label" >Remark 3</label><br></br>
                                    <textarea className="form-control" rows='3' name="Remark3" onChange={(e) => this.handleMDInputTextareaChange(e, 2)} value={(RemarksList && RemarksList !== []) ? RemarksList[2].remarks : ''}></textarea>
                                </div>
                            </div>
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Product Information</h5></div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label" >Product Name</label><br></br>
                                    <input className="form-control" type="text" name="productName" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.productName}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Product Number</label><br></br>
                                    <input className="form-control" type="text" name="productNumber" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.productNumber}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" name="address" >Deliver Amount</label><br></br>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <input className="form-control" type="text" name="productQuantityAmount" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.productQuantityAmount}></input>
                                        </div>
                                        <div className="col-lg-6">
                                            <select className="form-control" name="productMetricUnit" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.productMetricUnit}>
                                                <option value="unit" >unit</option>
                                                <option value="piece" >piece</option>
                                                <option value="kg" >kg</option>
                                                <option value="m3" >m3</option>
                                                <option value="m2">m2</option>
                                                <option value="m">m</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <label className="form-label" name="productinfo" >Product Information</label><br></br>
                                    <textarea className="form-control" type="text" rows="3" name="productInfo" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.productInfo}></textarea>
                                </div>
                            </div>
                            <div className=" card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="flex card-title ml-2 mt-2" style={{ color: "092a51" }}>Materials Information
                                    <div
                                        onClick={() => this.MISidePane()}>
                                        <AddIcon /></div></h5></div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-lg-6">
                                    <label className="form-label" >This materials information shows the amount of hazardous materials contained in</label></div>
                                <div className="col-lg-3">
                                    <input className="form-control" type="text" name="materialQuantityAmount" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.materialQuantityAmount}></input>
                                </div>
                                <div className="col-lg-3">
                                    <select className="form-control" name="materialMetricUnit" onChange={(e) => this.handleMDInputChange(e)} value={this.state.MDInput.materialMetricUnit}>
                                        <option value="unit">unit</option>
                                        <option value="piece" >piece</option>
                                        <option value="kg" >kg</option>
                                        <option value="m3" >m3</option>
                                        <option value="m2" >m2</option>
                                        <option value="m" >m</option>
                                    </select>
                                </div>
                            </div>
                            {
                                this.state.MIRenderArray && this.state.MIRenderArray.length ? this.renderMICardData(this.state.MIRenderArray, 'Other') : null
                            }
                            <div className=" card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="flex card-title ml-2 mt-2" style={{ color: "092a51" }}>EU Regulation
                                    <div
                                        onClick={() => this.EURegulationSidePane()}>
                                        <AddIcon /></div></h5></div>
                            </div>
                            {
                                this.state.EURenderArray && this.state.EURenderArray.length ? this.renderMICardData(this.state.EURenderArray, 'EU Reg') : null
                            }
                            <div className=" card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="flex card-title ml-2 mt-2" style={{ color: "092a51" }}>MD related documents
                                    <div
                                        onClick={() => this.RDSidePane()}>
                                        <AddIcon />
                                    </div></h5>
                                </div>
                            </div>
                            {this.state.RDRenderArray && this.state.RDRenderArray.length ? this.renderRDCardData(this.state.RDRenderArray) : null}
                            <div className="col-lg-12 mt-2">
                                <label className="form-label" ></label><br></br>
                                <div className="form-group search-btn-col" style={{ textAlign: 'end' }}>
                                    <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.updateMD()}> Update </button>
                                
                                    <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.CancelMD()}> Cancel </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {ShowMISidePan ? <div className="col-lg-6 p-4"><div className="panel-box search-filter-box mb-4">
                        <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                            <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Materials Information</h5></div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <label className="form-label" >Table</label><br></br>
                                    <AutoComplete value={this.state.MItempArray.tableValue}  onChange={(e) => this.handleMIInputChange(e)}
                                    suggestions={this.state.MITableDropDown} completeMethod={this.suggestMItable.bind(this)} 
                                    name="tableValue"
                                    inputStyle={{borderColor:"#ced4da"}}
                                    />
                            </div>
                            <div className="col-lg-4">
                                <label className="form-label" >Material Name</label><br></br>
                                    <AutoComplete value={this.state.MItempArray.materialName}  onChange={(e) => this.handleMIInputChange(e)}
                                    suggestions={this.state.MIMaterialNameDropDown} completeMethod={this.suggestMImaterial.bind(this)} 
                                    name="materialName"
                                    inputStyle={{borderColor:"#ced4da"}}
                                    />
                            </div>
                            <div className="col-lg-4">
                                <label className="form-label" >Threshold Value</label><br></br>
                                    <AutoComplete value={this.state.MItempArray.thresholdValue}  onChange={(e) => this.handleMIInputChange(e)}
                                    suggestions={this.state.MITVDropDown} completeMethod={this.suggestMIthreshold.bind(this)} 
                                    name="thresholdValue"
                                    inputStyle={{borderColor:"#ced4da"}}
                                    />
                            </div>

                            <div className="col-lg-12">
                                <label className="form-label" >Present Above Threshold Value</label>

                                <input type="checkbox" checked={this.state.MICheckBox} style={{ marginLeft: '7px' }} onChange={(e) => this.handleMICheckBoxChange(e)}></input>
                            </div>
                        </div>
                        {this.state.MICheckBox ?
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label" >Mass</label><br></br>
                                    <input className="form-control" type="text" name="mass" onChange={(e) => this.handleMIInputChange(e)} value={this.state.MItempArray !== 0 ? this.state.MItempArray.mass : ''}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >Unit</label><br></br>
                                    <input className="form-control" type="text" name="unit" onChange={(e) => this.handleMIInputChange(e)} value={this.state.MItempArray !== 0 ? this.state.MItempArray.unit : ''}></input>
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >Information on where it is used</label><br></br>
                                    <input className="form-control" type="text" name="informationOnUsage" onChange={(e) => this.handleMIInputChange(e)} value={this.state.MItempArray !== 0 ? this.state.MItempArray.informationOnUsage : ''}></input>
                                </div>
                            </div> : null
                        }
                        {this.state.MItempCardNo ?
                            
                            <div className="col-lg-12 mt-2">
                                <label className="form-label" ></label><br></br>
                                <div className="form-group search-btn-col" style={{ textAlign: 'end' }}>
                                    <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.UpdateMIData(this.state.MItempCardNo - 1)}> Update </button>

                                    <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.DeleteMIData(this.state.MItempCardNo - 1)}> Delete </button>
                                </div>
                            </div> :
                            <div className="col-lg-12 mt-2">
                                <label className="form-label" ></label><br></br>
                                <div className="form-group search-btn-col" style={{ textAlign: 'end' }}>
                                    <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.AddMIData()}> Add </button>

                                    <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.CancelSidepan("MI")}> Cancel </button>
                                </div>
                            </div>
                        }

                    </div>
                    </div> : ''}
                    {ShowEURegSidePan ?
                        <div className="col-lg-6 p-4"><div className="panel-box search-filter-box mb-4">
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>EU Regulation</h5></div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label" >EU reg Table</label><br></br>
                                    <AutoComplete value={this.state.EUtempArray.tableValue}  onChange={(e) => this.handleEuInputChange(e)}
                                    suggestions={this.state.EUTableDropDown} completeMethod={this.suggestEUtable.bind(this)} 
                                    name="tableValue"
                                    inputStyle={{borderColor:"#ced4da"}}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >Material Name</label><br></br>
                                    <AutoComplete value={this.state.EUtempArray.materialName}  onChange={(e) => this.handleEuInputChange(e)}
                                    suggestions={this.state.EUMaterialNameDropDown} completeMethod={this.suggestEUmaterial.bind(this)} 
                                    name="materialName"
                                    inputStyle={{borderColor:"#ced4da"}}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label" >Threshold Value</label><br></br>
                                    <AutoComplete value={this.state.EUtempArray.thresholdValue}  onChange={(e) => this.handleEuInputChange(e)}
                                    suggestions={this.state.EUTVDropDown} completeMethod={this.suggestEUthreshold.bind(this)} 
                                    name="thresholdValue"
                                    inputStyle={{borderColor:"#ced4da"}}
                                    />
                                </div>

                                <div className="col-lg-12">
                                    <label className="form-label" >Present</label>
                                    <input type="checkbox" checked={this.state.EuCheckBox} style={{ marginLeft: '7px' }} onChange={this.handleEuCheckBoxChange}></input>
                                </div>
                            </div>
                            {this.state.EuCheckBox ?
                                <div className="row">
                                    <div className="col-lg-4">
                                        <label className="form-label" >Mass</label><br></br>
                                        <input className="form-control" type="text" name="mass" onChange={(e) => this.handleEuInputChange(e)} value={this.state.EUtempArray !== 0 ? this.state.EUtempArray.mass : ''}></input>
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="form-label" >Unit</label><br></br>
                                        <input className="form-control" type="text" name="unit" onChange={(e) => this.handleEuInputChange(e)} value={this.state.EUtempArray !== 0 ? this.state.EUtempArray.unit : ''}></input>
                                    </div>
                                    <div className="col-lg-4">
                                        <label className="form-label" >Information on where it is used</label><br></br>
                                        <input className="form-control" type="text" name="informationOnUsage" onChange={(e) => this.handleEuInputChange(e)} value={this.state.EUtempArray !== 0 ? this.state.EUtempArray.informationOnUsage : ''}></input>
                                    </div>
                                </div> : null}
                            {this.state.EUtempcardNo ?
                                //(this.state.EUtempcardNo != null&&this.state.EUtempcardNo != "")||this.state.EUtempcardNo == 0 ?
                                <div className="col-lg-12 mt-2">
                                    <label className="form-label" ></label><br></br>
                                    <div className="form-group search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.UpdateEUData(this.state.EUtempcardNo - 1)}> Update </button>

                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.DeleteEUData(this.state.EUtempcardNo - 1)}> Delete </button>
                                    </div>
                                </div> :
                                <div className="col-lg-12 mt-2">
                                    <label className="form-label" ></label><br></br>
                                    <div className="form-group search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.AddEUData()}> Add </button>

                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.CancelSidepan("EU")}> Cancel </button>
                                    </div>
                                </div>
                            }
                        </div>
                        </div> : ''}
                  
                    {ShowRDSidePan ?
                        <div className="col-lg-6 p-4">
                            <div className="panel-box search-filter-box mb-4">
                                <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                    <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>MD related documents</h5></div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <label className="form-label" >Document Creation Organization</label><br></br>
                                        <input className="form-control" type="text" name="attachmentType" onChange={(e) => this.handleRDInputChange(e)} value={this.state.RDtempArray.attachmentType}></input>
                                    </div>
                                    <div className="col-lg-12">
                                        <label className="form-label"  >Remarks</label><br></br>
                                        <textarea className="form-control" rows="6" name="remarks" onChange={(e) => this.handleRDInputChange(e)} value={this.state.RDtempArray.remarks}></textarea>
                                    </div>
                                    <div className="col-lg-6">
                                        <label className="form-label" >Date of Preparation</label><br></br>
                                        <div className='input-group add-on date datepicker'
                                            data-date-format="yyyy-mm-dd">
                                            <input name='name' type="text" placeholder="Enter the Date" className="form-control date-picker"
                                                data-date-format="yyyy-mm-dd" value={this.state.RDtempArray.dateOfDeclaration} />
                                            <DatePicker selected={this.state.SelectedRDDate} onChange={this.handleRDDateChange}
                                                open={this.state.RDDatePickerIsOpen}  onClickOutside={this.handleBlur}
                                                showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                                className="form-control date-picker w-5 hide-date" />
                                            <div className="input-group-btn calendar-icon">
                                                <button className="btn btn-default" onClick={this.openRDDatePicker}>
                                                    <i className="fa fa-calendar mt-1" ></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <label className="form-label" >Title</label><br></br>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Browse File<input type="file" id="files" name="documentCreationOrganization" onChange={(e) => this.handleRDInputChange(e)} /></span>
                                            </div>    
                                                <input type="text" class="form-control" placeholder="" value={this.state.RDtempArray.documentCreationOrganization} />
                                                {
                                                    this.state.RDtempArray.documentCreationOrganization ? <div class="input-group-append">
                                                        <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInput()}></i>
                                                    </div> : ''
                                                }
                                        </div>
                                    </div>
                                    {this.state.RDtempcardNo ?
                                        <div className="col-lg-12 mt-2">
                                            <label className="form-label" ></label><br></br>
                                            <div className="form-group search-btn-col" style={{ textAlign: 'end' }}>
                                                <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.updateRDData(this.state.RDtempcardNo - 1)}> update </button>

                                                <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.DeleteRDData(this.state.RDtempcardNo - 1)}> Delete </button>
                                            </div>
                                        </div> :
                                        <div className="col-lg-12 mt-2">
                                            <label className="form-label" ></label><br></br>
                                            <div className="form-group search-btn-col" style={{ textAlign: 'end' }}>
                                                <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.AddRDData()}> Add </button>

                                                <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.CancelSidepan("RD")}> Cancel </button>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                        </div> : ''
                    }
                </div>
            </div>
        )

    }
    renderRDCardData = (data) => {
        return data && data.length
            ? data.map((item, index) => {
                return (
                    <div className="card MM-card-content click" style={{ backgroundColor: "#f0f0f0" }} onClick={() => this.editRDCard(index)}>
                        <div className="p-3">
                            <div className="resource-list-auth-date">
                                <div className="row">
                                    <div className="col-sm-6 mb-2">
                                        <span><strong>Title:</strong><span className="italicFont "> {item.attachmentName}&nbsp;&nbsp;<i className="fa fa-paperclip fa-lg" style={{width :20}} onClick={() => this.downloadAttachment(item.attachmentName, item.attachmentGuid)}></i></span></span>
                                    </div>
                                    <div className="col-sm-6 mb-2">
                                        <span><strong>Remarks: </strong><span className="italicFont ">{item.remarks}</span></span>
                                    </div>
                                    <div className="col-sm-6">
                                        <span><strong>Date of Preparation: </strong><span className="italicFont ">{item.dateOfDeclaration}</span></span>
                                    </div>
                                    <div className="col-sm-6">
                                        <span><strong>Document Creation: </strong><span className="italicFont ">{item.documentCreationOrganization}</span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }) : null
    }
    renderMICardData = (data, tableName) => {
        return data && data.length
            ? data.map((elament, index) => {
                return (
                    <div className="card MM-card-content click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }} onClick={() => this.editMICard(index, tableName)}>
                        {!elament.isContainAboveThreshold ? <div className="arrow-right-green"></div> : <div className="arrow-right-red"></div>}
                        <div className="p-3">
                            <div className="resource-list-auth-date">
                                <div className="row">
                                    <div className="col-sm-6 mb-2">
                                        <span><strong>Table: </strong><span className="italicFont ">{elament.tableValue}</span></span>
                                    </div>
                                    <div className="col-sm-6 mb-2">
                                        <span><strong>Material Name: </strong><span className="italicFont "> {elament.materialName}</span></span>
                                    </div>
                                    <div className="col-sm-6 mb-2">
                                        <span><strong>Threshold Value: </strong><span className="italicFont "> {elament.thresholdValue}</span></span>
                                    </div>
                                </div>
                                {elament.isContainAboveThreshold ?
                                    <div className="row">
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Mass: </strong><span className="italicFont "> {elament.mass}</span></span>
                                        </div>
                                        <div className="col-sm-6">
                                            <span><strong>Unit: </strong><span className="italicFont ">{elament.unit} </span></span>
                                        </div>
                                        <div className="col-sm-6">
                                            <span><strong>Information on where it is Used: </strong><span className="italicFont ">{elament.informationOnUsage} </span></span>
                                        </div></div> : null}
                            </div>
                        </div>
                    </div>
                );
            }) : null
    }
    CancelSidepan = (type) => {
        if (type === "MI") {
            this.props.dispatch({ type: 'ShowMISidePan', data: false });
        } else if (type === "EU") {
            this.props.dispatch({ type: 'ShowEURegSidePan', data: false });
        } else if (type === "RD") {
            this.props.dispatch({ type: 'ShowRDSidePan', data: false });
        }
        document.body.scrollTop=0;
        document.documentElement.scrollTop=1000;
    }
    MISidePane = () => {
        let params = { ...MIlistInput }
        this.setState({
            MItempArray: params
        });
        this.state.MItempCardNo = 0;
        document.body.scrollTop=0;
        document.documentElement.scrollTop=300;
        this.props.dispatch({ type: 'ShowMISidePan', data: true });
        appService.getMaterialDetail("other","","","").then(response => {
            if(response.data[0]){
                this.setState({
                    MItable:response.data[0].tablevalue,
                    GetMaterialInfo:true
                });
            }
        })
    }
    RDSidePane = () => {
        let params = { ...RDlistInput }
        this.setState({
            RDtempArray: params
        });
        this.state.RDtempcardNo = 0;
        document.body.scrollTop=0;
        document.documentElement.scrollTop=300;
        this.props.dispatch({ type: 'ShowRDSidePan', data: true });
    }
    EURegulationSidePane = () => {
        let params = { ...EulistInput }
        this.setState({
            EUtempArray: params
        });
        this.state.EUtempcardNo = 0;
        document.body.scrollTop=0;
        document.documentElement.scrollTop=300;
        this.props.dispatch({ type: 'ShowEURegSidePan', data: true });
        appService.getMaterialDetail("EU","","","").then(response => {
            if(response.data[0]){
                this.setState({
                    EUtable:response.data[0].tablevalue,
                    GetMaterialInfo:true
                });
            }
        })
    }
    downloadAttachment(fileName, guid) {
        const { dispatch } = this.props;
        let data = {};
        data.attachmentName = fileName;
        data.attachmentGuid = guid;
        dispatch(DownloadAttachment(data));
    }

}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {

    return {
        mdDetailList: state.SidePanReducer.mdDetailList,
        ShowMISidePan: state.SidePanReducer.ShowMISidePan || false,
        ShowRDSidePan: state.SidePanReducer.ShowRDSidePan || false,
        ShowEURegSidePan: state.SidePanReducer.ShowEURegSidePan || false,
        declarationID: state.SidePanReducer.declarationID,
        MIOthersList: state.SidePanReducer.MIOthersList,
        MIEuList: state.SidePanReducer.MIEuList,
        RDList: state.SidePanReducer.RDList,
        attachmentDetail: state.SidePanReducer.attachmentDetail,
        isAttachment: state.SidePanReducer.isAttachment,
        RemarksList: state.SidePanReducer.RemarksList,
        MInfoList: state.SidePanReducer.MInfoList,
        userDisplayName: state.SidePanReducer.userDisplayName,
        MdAttachment:state.SidePanReducer.MdAttachment
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MDEdit));
